"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'config.tooltips.chat.pick.kdb': 'Select knowledge database for enhanced responses',
    'config.tooltips.chat.settings': 'Open chat settings to configure options',
    'config.tooltips.send.prompt': 'Send prompt',
    'config.tooltips.prompt.with.microphone': 'Prompt with microphone',
    'config.tooltips.attach.file.to.prompt': 'Attach file to prompt',
    'config.tooltips.cancel.request': 'Cancel request',
};
